import React from 'react';
import DialogBase from '../Shared/DialogBase';
import { Box, Button, Stack, TextField } from '@mui/material';
import * as clipboard from 'clipboard-polyfill';
import { Share } from '@mui/icons-material';
import { useSnackbar } from 'notistack';

export interface ShareFileDialogProps {
    open: boolean;
    onClose: () => void;
    shareUrl: string;
}

export default function ShareFileDialog(props: ShareFileDialogProps) {
    const { open, onClose, shareUrl } = props;
    const [copied, setCopied] = React.useState(false);
    const textFieldRef = React.useRef<HTMLInputElement>(null);
    const { enqueueSnackbar } = useSnackbar();
    const handleCopy = async () => {
        try {
            await clipboard.writeText(shareUrl);
            setCopied(true);
            setTimeout(() => setCopied(false), 1500);
            enqueueSnackbar('Odkaz zkopírován do schránky. Platnost je 3 měsíce.', { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'center' } });
        } catch (e) {
            setCopied(false);
        }
    };

    return (
        <DialogBase showCloseButton minWidth={1000} open={open} onClose={onClose} title="Sdílet soubor">
            <Stack p={1} spacing={2}>
                <TextField
                    inputRef={textFieldRef}
                    value={shareUrl}
                    fullWidth
                    label="Odkaz ke sdílení"
                    InputProps={{ readOnly: true }}
                    variant="outlined"
                />
                {/* <Box display="flex" justifyContent="flex-end"> */}
                <Button variant="contained" startIcon={<Share />} color={copied ? 'success' : 'primary'} onClick={handleCopy}>
                    {copied ? 'Zkopírováno!' : 'Kopírovat odkaz'}
                </Button>
                {/* </Box> */}
            </Stack>
        </DialogBase>
    );
}
